import React, { createContext, useContext, useState, useEffect } from "react";
import { useApi } from "../hooks/useApi";
import { useAuth } from "./AuthContext"; // assuming tenantId is in user

const OrganizationContext = createContext([]);

export const OrganizationProvider = ({ children }) => {
  const [organizations, setOrganizations] = useState([]);
  const apiCall = useApi();
  const { user } = useAuth(); // check if user contains tenantId

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        if (!user?.tenantId) {
        //  console.warn("No tenantId available for fetching organizations");
          return;
        }
        const data = await apiCall("GET", `/organizations`);
        setOrganizations(data);
      } catch (error) {}
    };
    fetchOrganizations();
  }, [user?.tenantId]);

  return (
    <OrganizationContext.Provider value={organizations}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganizations = () => useContext(OrganizationContext);
